import { GeneratedDiscountCodeReuseStatus } from "@redotech/redo-discounts-common/generated-discount-code-reuse-status";
import { DiscountDbParser } from "@redotech/redo-model/discount/discount-db-parser";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const fetchDiscountInfo = {
  name: "fetchDiscountInfo" as const,
  input: z.object({ conversationId: zExt.objectId() }),
  output: z.object({
    success: z.boolean(),
    errorMessage: z.string().optional(),
    discountCode: z.string().optional(),
    discountLink: z.string().optional(),
    discountCodeReuseStatus: z
      .enum(GeneratedDiscountCodeReuseStatus)
      .optional(),
    discountCodeUsedOrderNumber: z.string().optional(),
    discountConfig: DiscountDbParser.optional(),
  }),
};
